module.exports = __webpack_public_path__ + "static/media/srt_h.ed08c664.svg";